/* eslint-disable */
import { useState } from 'react';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Popover from '@mui/material/Popover';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Iconify from '../../components/iconify';
import Label from '../../components/label';


// ----------------------------------------------------------------------

export default function UserTableRow({
  userId,
  username,
  phoneno,
  email,
  avatarUrl,
  status,
  gender,
  dateOfBirth,
  userType,
  cityState,
  country,
  handleDeleteUserClick,
}) {
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };
  // const handleEditButton = () => {
  //   navigate(`/admin/user/${userId}/edit`);
  //   setOpen(null);
  // };
  const handleEditButton = () => {
    navigate(`/admin/user/${userId}/edit`, { 
        state: {
            id: userId,
            username,
            email,
            phoneno,
            gender: gender || 'male',
            dateOfBirth,
            userType: userType || 'fan', 
            cityState,
            country,
            status,
            avatarUrl,
            image: avatarUrl // Pass the full image URL
        } 
    });
    setOpen(null);
};

  
  const handleDeleteButton = (event) => {
    handleDeleteUserClick(userId)
    setOpen(null);
  };
  
  const handleCloseMenu = () => {
    setOpen(null);
  };

  return (
    <>
      <TableRow hover tabIndex={-1} role="checkbox">
        {/* <TableCell padding="checkbox">
          <Checkbox disableRipple checked={selected} onChange={handleDeleteUserClick} />
        </TableCell> */}

        <TableCell >
          <Avatar alt={username} src={avatarUrl} />
        </TableCell>
        <TableCell component="th" scope="row" padding="none">
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="subtitle2" noWrap>
              {username}
            </Typography>
          </Stack>
        </TableCell>

        
        <TableCell>{email}</TableCell>
        <TableCell>{phoneno}</TableCell>
        <TableCell>
          <Label color={(status === 0 && 'error') || 'success'}>{status===0?"Banned":"Active"}</Label>
        </TableCell>

        <TableCell align="right">
          <IconButton onClick={handleOpenMenu}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>
      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: { width: 140 },
        }}
      >
        <MenuItem onClick={()=>{
          handleEditButton()}}>
          <Iconify icon="eva:edit-fill" sx={{ mr: 2 }} />
          Edit
        </MenuItem>
        <MenuItem onClick={handleDeleteButton} sx={{ color: 'error.main' }}>
          <Iconify icon="eva:trash-2-outline" sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Popover>
    </>
  );
}

UserTableRow.propTypes = {
  userId: PropTypes.string.isRequired,
  avatarUrl: PropTypes.any,
  handleDeleteUserClick: PropTypes.func,
  phoneno: PropTypes.string,
  email: PropTypes.string,
  username: PropTypes.string,
  status: PropTypes.number,
};
